import { createSlice } from "@reduxjs/toolkit";
import React from "react";

const initialState = {
  datePickData: null,
};

const DatePickerReducer = createSlice({
  name: "DatePickerReducer",
  initialState: initialState,
  reducers: {
    setDate: (state, { payload }) => {
      console.log("open", payload);
      return {
        ...state,
        datePickData: payload,
      };
    },
    clearDate: (state) => {
      return {
        ...state,
        datePickData: null,
      };
    },
  },
});

export default DatePickerReducer;
